/**
 * Wrapper for @revalize/notifications NotificationProvider
 *
 * Integrates with the app's auth system to provide authenticated
 * notification API calls.
 */

import React from 'react'
import { NotificationProvider } from '@revalize/notifications/react'
import { useAuthState } from '@revalize/auth/frontend'
import { ConfigService } from '@/services/ConfigService'

interface NotificationProviderWrapperProps {
  children: React.ReactNode
}

export function NotificationProviderWrapper({
  children,
}: NotificationProviderWrapperProps): React.ReactElement {
  const authState = useAuthState({ baseUrl: ConfigService.getApiBaseUrl() })

  const getHeaders = async (): Promise<Record<string, string>> => {
    try {
      const token = await authState.getAppToken()
      if (token) {
        return { Authorization: `Bearer ${token}` }
      }
    } catch {
      // Silently fail - user may not be authenticated
    }
    return {}
  }

  return (
    <NotificationProvider
      config={{
        apiUrl: '/api/notifications',
        getHeaders,
      }}
    >
      {children}
    </NotificationProvider>
  )
}
